import { TRACKER_NAME } from 'personalization-lib/constants/tracking/tracker';
const throwTrackingError = () => {
  throw new Error('Tracker not initialized\nPlease ensure your component is wrapped in PersonalizationWrapper');
};
export const exceptionTracker = {
  track: () => throwTrackingError(),
  clone: () => throwTrackingError(),
  getConfig: () => throwTrackingError(),
  setProperties: () => throwTrackingError()
};
export const getNormalizedTracker = tracker => {
  if (!tracker) {
    return exceptionTracker;
  }

  // Check if tracker is already standalone
  if ('standalone' in tracker) {
    return tracker.clone({
      standalone: true,
      trackerName: TRACKER_NAME
    });
  }

  // Convert legacy tracker to standalone for internal use
  return tracker.clone({
    standalone: true,
    preserveTrackerProperties: false,
    trackerName: TRACKER_NAME
  });
};